export function getQualityEntryAttachmentMax(
  attachmentsEnabled?: boolean,
  attachmentsLimited?: boolean,
  attachmentMaxOverride?: number
) {
  return attachmentsEnabled
    ? attachmentMaxOverride || attachmentMaxOverride === 0
      ? attachmentMaxOverride
      : attachmentsLimited
        ? 1
        : undefined
    : undefined;
}
